import { render, staticRenderFns } from "./sysclassify.vue?vue&type=template&id=74fd6cc4&scoped=true"
import script from "./sysclassify.vue?vue&type=script&lang=js"
export * from "./sysclassify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fd6cc4",
  null
  
)

export default component.exports